var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import Button from "@irati/ui/src/Button";
import padding from "@irati/ui/src/global/padding";
import ProfilePic from "@irati/ui/src/ProfilePicture";
import id from "@irati/utils/id";
import { FormattedMessage } from "@irati/utils/lang";
import ProfilePicPopup from "../Popup/ProfilePic";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-bottom: ", ";\n"])), padding.base);
var EditProfilePic = /** @class */ (function (_super) {
    __extends(EditProfilePic, _super);
    function EditProfilePic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popup = null;
        _this.getText = function () {
            var user = _this.props.auth.user;
            return user.profileImageUrl ? (React.createElement(FormattedMessage, { id: "account.profile.fields.picture.editButton" })) : (React.createElement(FormattedMessage, { id: "account.profile.fields.picture.addButton" }));
        };
        _this.handleShow = function () { var _a; return (_a = _this.popup) === null || _a === void 0 ? void 0 : _a.show(); };
        return _this;
    }
    EditProfilePic.prototype.render = function () {
        var _this = this;
        var user = this.props.auth.user;
        return (React.createElement("div", null,
            React.createElement(Container, null,
                React.createElement(ProfilePic, { id: id("picture", this.props), user: user, large: true }),
                React.createElement(Button, { id: id("btn", this.props), onClick: this.handleShow, marginLeft: 2, small: true }, this.getText())),
            React.createElement(ProfilePicPopup, { ref: function (c) {
                    _this.popup = c;
                }, user: user })));
    };
    EditProfilePic.defaultProps = {
        id: "editProfilePic"
    };
    return EditProfilePic;
}(Component));
export default withAuth(EditProfilePic);
var templateObject_1;
